import * as CookieConsent from 'vanilla-cookieconsent';

const consentDurationDays = 182;
const consentDurationLabel = '6 months';

const privacyPolicyUrl = '/privacy-policy/';
const cookiePolicyUrl = '/privacy-policy#cookie-policy';
const contactUrl = '/contact/';

const currentDomain = window.location.hostname;

window.dataLayer = window.dataLayer || [];
function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
}

function consentSignals(isAccepted) {
    const marketing = isAccepted('marketing') ? 'granted' : 'denied';

    return {
        analytics_storage: isAccepted('analytics') ? 'granted' : 'denied',
        ad_storage: marketing,
        ad_user_data: marketing,
        ad_personalization: marketing,
        functionality_storage: isAccepted('functionality') ? 'granted' : 'denied',
        personalization_storage: isAccepted('personalization') ? 'granted' : 'denied',
        security_storage: isAccepted('security') ? 'granted' : 'denied',
    };
}

const savedCategories = CookieConsent.getCookie('categories');
if (savedCategories) {
    gtag(
        'consent',
        'update',
        consentSignals((category) => savedCategories.includes(category)),
    );
}

function manageConsent() {
    gtag('consent', 'update', consentSignals(CookieConsent.acceptedCategory));
}

window.addEventListener('load', () => {
    /**
     * All config. options available here:
     * https://cookieconsent.orestbida.com/reference/configuration-reference.html
     */
    CookieConsent.run({
        autoClearCookies: true,

        cookie: {
            name: 'cc_cookie',
            expiresAfterDays: consentDurationDays,
        },

        categories: {
            necessary: {
                enabled: true, // this category is enabled by default
                readOnly: true, // this category cannot be disabled
            },
            analytics: {
                autoClear: {
                    cookies: [{ name: /^_ga/ }, { name: '_gid' }, { name: /^__hs/ }, { name: 'hubspotutk' }],
                },
            },
            marketing: {
                autoClear: {
                    cookies: [{ name: /^__Secure-/ }, { name: /^(APISID|HSID|NID|1P_JAR|AEC|SEARCH_SAMESITE)$/ }],
                },
            },
        },

        language: {
            default: 'en',
            translations: {
                en: {
                    consentModal: {
                        title: 'We value your privacy',
                        description: `We use cookies to run this site, to measure how it is used and to show you relevant advertising. Only strictly necessary cookies are set unless you agree to the others — you can accept all, reject all, or choose category by category. Your choice is stored for ${consentDurationLabel} and can be changed at any time from the 'Cookie settings' link in the footer.`,
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        showPreferencesBtn: 'Manage preferences',
                        closeIconLabel: 'Reject all and close',
                        footer: `<a href="${privacyPolicyUrl}">Privacy Policy</a>\n<a href="${cookiePolicyUrl}">Cookie Policy</a>`,
                    },
                    preferencesModal: {
                        title: 'Cookie preferences',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Save preferences',
                        closeIconLabel: 'Close modal',
                        serviceCounterLabel: 'Service|Services',
                        sections: [
                            {
                                title: null,
                                description:
                                    'We use cookies to help you navigate efficiently and to perform certain functions. Detailed information about every cookie can be found under each category below.<br><br>You can enable or disable each category independently. Strictly necessary cookies cannot be turned off, because the site would not work without them. Disabling the others has no effect on your ability to browse the site.',
                            },
                            {
                                title: "Strictly necessary cookies <span class='pm__badge'>Always enabled</span>",
                                description:
                                    'These cookies are essential to the basic functionality of the site and to remembering the choice you make on this banner. They store no personally identifiable information and are exempt from consent under PECR.',
                                linkedCategory: 'necessary',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: 'cc_cookie',
                                            description:
                                                'Stores your cookie preferences so that we do not ask you again on every visit.',
                                            domain: currentDomain,
                                            expiration: consentDurationLabel,
                                        },
                                        {
                                            name: '_GRECAPTCHA',
                                            description:
                                                'Set by Google reCAPTCHA, which protects the site against spam submissions on contact forms.',
                                            domain: 'google.com',
                                            expiration: '6 months',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Analytics cookies',
                                description:
                                    'These cookies tell us how the site is used — how many visitors arrive, where they come from, which pages they read and where they leave. We use them to improve the site. They are never used to show you advertising.',
                                linkedCategory: 'analytics',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '_ga',
                                            description:
                                                'Set by Google Analytics to distinguish unique visitors by assigning a randomly generated number. Used to calculate visitor, session and campaign data for the site usage reports.',
                                            domain: currentDomain,
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '_ga_*',
                                            description:
                                                'Set by Google Analytics 4 to persist the state of the current session.',
                                            domain: currentDomain,
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '_gid',
                                            description:
                                                'Set by Google Analytics to store information about how visitors use the site, in an anonymous form, and to help build the analytics report.',
                                            domain: currentDomain,
                                            expiration: '1 day',
                                        },
                                        {
                                            name: 'OTZ',
                                            description:
                                                'Set by Google Analytics to provide an aggregate analysis of website visitors.',
                                            domain: 'google.com',
                                            expiration: '1 month',
                                        },
                                        {
                                            name: '__hstc',
                                            description:
                                                'Main HubSpot analytics cookie. Tracks visits to the site, recording the timestamp of the first visit, the previous visit and the current visit.',
                                            domain: currentDomain,
                                            expiration: '6 months',
                                        },
                                        {
                                            name: 'hubspotutk',
                                            description:
                                                'Set by HubSpot to keep track of a visitor identity. It is passed along with form submissions and used to de-duplicate contacts.',
                                            domain: currentDomain,
                                            expiration: '6 months',
                                        },
                                        {
                                            name: '__hssc',
                                            description:
                                                'Set by HubSpot to track sessions, in order to determine whether the session count should change.',
                                            domain: currentDomain,
                                            expiration: '30 minutes',
                                        },
                                        {
                                            name: '__hssrc',
                                            description:
                                                'Set by HubSpot to determine whether the visitor has restarted their browser.',
                                            domain: currentDomain,
                                            expiration: 'Session',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'Marketing cookies',
                                description:
                                    'These cookies are set by Google advertising services. They build a profile of your interests so that the ads you are shown — on this site and elsewhere — are relevant to you, and they measure how those ads perform. Rejecting this category does not reduce what you can do on the site.',
                                linkedCategory: 'marketing',
                                cookieTable: {
                                    headers: {
                                        name: 'Name',
                                        description: 'Description',
                                        domain: 'Domain',
                                        expiration: 'Expiration',
                                    },
                                    body: [
                                        {
                                            name: '__Secure-1PAPISID',
                                            description:
                                                "Used for targeting purposes, to build a profile of the visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-3PAPISID',
                                            description:
                                                "Used for targeting purposes, to build a profile of the visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-1PSID',
                                            description:
                                                "Used for targeting purposes, to build a profile of the visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-3PSID',
                                            description:
                                                "Used for targeting purposes, to build a profile of the visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: '__Secure-1PSIDCC',
                                            description:
                                                "Used for targeting purposes, to build a profile of the visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: '__Secure-3PSIDCC',
                                            description:
                                                'Used by Google to build a profile of visitor interests, in order to show relevant and personalised ads through retargeting.',
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: '__Secure-1PSIDTS',
                                            description:
                                                "Used for targeting purposes, to build a profile of the visitor's interests in order to show relevant and personalised Google advertising.",
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: 'APISID',
                                            description:
                                                'Used by Google to display personalised advertisements on Google sites, based on recent searches and previous interactions.',
                                            domain: 'google.com',
                                            expiration: '1 year',
                                        },
                                        {
                                            name: 'HSID',
                                            description:
                                                'Contains digitally signed and encrypted records of a Google Account ID and the most recent sign-in time.',
                                            domain: 'google.com',
                                            expiration: '2 years',
                                        },
                                        {
                                            name: 'NID',
                                            description:
                                                'Used to show Google ads in Google services for signed-out users.',
                                            domain: 'google.com',
                                            expiration: '6 months',
                                        },
                                        {
                                            name: '1P_JAR',
                                            description:
                                                'Collects statistics on website usage and measures conversions. Also used to display relevant ads to users and to limit how often the same ad is shown.',
                                            domain: 'google.com',
                                            expiration: '1 month',
                                        },
                                        {
                                            name: 'AEC',
                                            description:
                                                'Used by Google to ensure that requests within a browsing session are made by the user, and not by other sites.',
                                            domain: 'google.com',
                                            expiration: '6 months',
                                        },
                                        {
                                            name: 'SEARCH_SAMESITE',
                                            description: 'Used for the correct sending of data to Google.',
                                            domain: 'google.com',
                                            expiration: '5 months',
                                        },
                                    ],
                                },
                            },
                            {
                                title: 'How long your choice is kept',
                                description: `Your preferences are saved in the <strong>cc_cookie</strong> cookie on this device for <strong>${consentDurationLabel}</strong>. After that we will ask you again. You can change or withdraw your consent at any time — it is as easy to withdraw as it was to give — using the 'Cookie settings' link in the footer of every page. When you withdraw consent, the cookies that were set under that category are deleted from this device.`,
                            },
                            {
                                title: 'More information',
                                description: `For more detail on how we handle your data, see our <a href="${privacyPolicyUrl}">Privacy Policy</a> and our <a href="${cookiePolicyUrl}">Cookie Policy</a>. If you have a question about either, please <a href="${contactUrl}">get in touch</a>.`,
                            },
                        ],
                    },
                },
            },
        },

        onFirstConsent: (...args) => {
            manageConsent(args);
            window.dataLayer.push({ event: 'consent_ready' });
        },
        onChange: (...args) => {
            manageConsent(args);
            window.dataLayer.push({ event: 'consent_update' });
        },
    });
});
